module.exports = __webpack_public_path__ + "static/img/L48804666.2b7769d8.jpg";